/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/style-prop-object */
/* eslint-disable no-unused-expressions */
import React, { useRef, useState, MutableRefObject, useEffect } from 'react';
import { Dialog, Button } from '@/components/uikit';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import { useTranslate } from '@/locale';
import { ReactComponent as DeleteAccountOtp } from '@/assets/images/delete_account_otp.svg';
import { TextField, IconButton } from '@material-ui/core';
import Close from '@material-ui/icons/Close';
import { regexNotNumber, beginWithZero } from '@/utils/helper';
import useDurationCountdown from '@/utils/hooks/useDurationCountdown';

interface DialogProps {
  isOpen: boolean;
  onClose: () => void;
  phoneNumber: string;
  cooldown: boolean;
  setCooldown: React.Dispatch<React.SetStateAction<boolean>>;
  handleRequestOtp: () => void;
  handleValidateOtp: (otp: string) => void;
}

interface OtpInputProps {
  name: string;
  autoFocus?: boolean;
  value: string;
}

const initialOtpInputs: OtpInputProps[] = [
  {
    name: 'inputOne',
    autoFocus: true,
    value: '',
  },
  {
    name: 'inputTwo',
    value: '',
  },
  {
    name: 'inputThree',
    value: '',
  },
  {
    name: 'inputFour',
    value: '',
  },
];

const OtpDialog = (props: DialogProps) => {
  const { translate } = useTranslate();
  const {
    isOpen,
    onClose,
    phoneNumber,
    cooldown,
    setCooldown,
    handleRequestOtp,
    handleValidateOtp,
  } = props;
  const [otpValues, setOtpValues] = useState(initialOtpInputs);
  const [isLoading, setLoading] = useState(false);

  const { minutes, seconds } = useDurationCountdown(cooldown ? 300 : 0);
  const otpFieldRefs: MutableRefObject<HTMLInputElement[] | null[]> = useRef(
    []
  );
  const otpContainEmpty = Boolean(otpValues.find(item => item.value === ''));

  const handleChange = (value: string, index: number) => {
    if (regexNotNumber(value) || value.length > 1) return;
    const newOtpValues = [...otpValues];
    newOtpValues[index].value = value;
    setOtpValues(newOtpValues);
    if (value.length === 1 && index < otpValues.length - 1) {
      otpFieldRefs.current[index + 1]?.focus();
    }
  };
  const handleBackspace = (evt: string, index: number) => {
    if (evt === 'Backspace') {
      if (otpValues[index].value) return;
      if (index > 0) {
        otpFieldRefs.current[index - 1]?.focus();
      }
    }
  };
  const handleClick = (index: number) => {
    // NOTE: on click input, focus on first empty input
    // and focus on last input if all inputs is filled.
    const firstEmptyInputIndex = otpValues.findIndex(item => !item.value);
    const focusToIndex =
      firstEmptyInputIndex >= 0 ? firstEmptyInputIndex : otpValues.length - 1;
    otpFieldRefs.current[focusToIndex]?.focus();
    // NOTE: prevent typing caret to be on beginning of the field ( |2 -> 2| ).
    if (otpValues[index].value && otpFieldRefs.current[index]) {
      otpFieldRefs.current[index]?.setSelectionRange(1, 1);
    }
  };
  const handleResendOtp = async () => {
    handleRequestOtp();
  };
  const handleSubmitOtp = async () => {
    setLoading(true);
    const otpString = otpValues.map(obj => obj.value).join('');
    await handleValidateOtp(otpString);
    setLoading(false);
  };

  useEffect(() => {
    if (!minutes && !seconds) {
      setCooldown(false);
    }
  }, [minutes, seconds]);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={isOpen}
      isWithDialogContent={false}
      PaperProps={{
        style: { borderRadius: 12 },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        style={{
          position: 'absolute',
          right: 8,
          top: 4,
        }}
      >
        <Close />
      </IconButton>
      <MuiDialogContent>
        <div style={{ textAlign: 'center' }}>
          <DeleteAccountOtp style={{ width: '149px', marginTop: '36px' }} />
          <p style={{ fontSize: '18px', fontWeight: 700 }}>
            {translate('inputOtpCode')}
          </p>
          <p>
            {translate('inputOtpCodeSentTo')}
            <br />
            {phoneNumber}
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {otpValues.map((input, index) => {
              return (
                <TextField
                  key={input.name}
                  inputRef={ref => {
                    otpFieldRefs.current[index] = ref;
                  }}
                  variant="outlined"
                  autoFocus={input.autoFocus}
                  value={otpValues[index].value}
                  onChange={evt => handleChange(evt.target.value, index)}
                  onKeyDown={evt => handleBackspace(evt.key, index)}
                  onClick={() => handleClick(index)}
                  style={{ margin: '4px' }}
                  inputProps={{
                    inputMode: 'numeric',
                    style: {
                      textAlign: 'center',
                      fontSize: '32px',
                      height: '65px',
                      maxWidth: '65px',
                      padding: 0,
                    },
                  }}
                />
              );
            })}
          </div>
          {cooldown ? (
            <p style={{ fontSize: '14px', color: '#36365566', margin: 12 }}>
              {translate('resendOtp')}{' '}
              <span style={{ color: '#363655CC' }}>
                {translate('in')}{' '}
                <b>
                  {beginWithZero(minutes)}:{beginWithZero(seconds)}
                </b>
              </span>
            </p>
          ) : (
            <Button
              variant="text"
              onClick={handleResendOtp}
              style={{ cursor: 'pointer', color: '#1F76FF', marginTop: 10 }}
            >
              {translate('resendOtp')}
            </Button>
          )}
        </div>
      </MuiDialogContent>
      <MuiDialogActions style={{ justifyContent: 'center' }}>
        <Button
          disabled={otpContainEmpty || isLoading}
          loading={isLoading}
          style={{
            marginTop: 0,
            borderRadius: '24px',
            padding: isLoading ? 15 : 10,
          }}
          onClick={handleSubmitOtp}
        >
          {translate('submit')}
        </Button>
      </MuiDialogActions>
    </Dialog>
  );
};

export default OtpDialog;
